/**
 * Combine all reducers in this file and export the combined reducers.
 */

export default function createReducer(initialState, actionHandlers) {
  return (state = initialState, action) => {
    const handler = actionHandlers[action.type];
    return handler ? handler(state, action) : state;
  };
}



// WEBPACK FOOTER //
// ./src/store/reducers.js